module.exports = __webpack_public_path__ + "img/map_toilet_3@2x.d1a23544.png";